import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getViewerProfilesQueryOptions } from "@/functions/profiles/get-viewer-profiles";

type PoolWithTeams = {
  id: number;
  teams: {
    teamId: number;
  }[];
};

type TeamWithPool = {
  id: number;
  team: {
    players: { profile: { id: number } }[];
  };
};

export function useViewerPoolIds(
  pools: PoolWithTeams[] | undefined,
  teamMap: Map<number, TeamWithPool>,
) {
  const { data: viewerProfiles, isPending } = useQuery(
    getViewerProfilesQueryOptions(),
  );

  const viewerProfileIds = useMemo(
    () => new Set(viewerProfiles?.map((p) => p.id)),
    [viewerProfiles],
  );

  const viewerPoolIds = useMemo(() => {
    const ids = new Set<number>();
    for (const pool of pools ?? []) {
      for (const poolTeam of pool.teams) {
        const team = teamMap.get(poolTeam.teamId);
        if (
          team?.team.players.some((p) => viewerProfileIds.has(p.profile.id))
        ) {
          ids.add(pool.id);
          break;
        }
      }
    }
    return ids;
  }, [pools, teamMap, viewerProfileIds]);

  return { viewerProfileIds, viewerPoolIds, isViewerPending: isPending };
}
